import { render } from "./HosPalReferralInformation.vue?vue&type=template&id=4702aaf6&ts=true"
import script from "./HosPalReferralInformation.ts?vue&type=script&lang=ts&external"
export * from "./HosPalReferralInformation.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__